import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useLazyQuery } from '@apollo/client'

import { CURRENT_FUTURE_SERIES } from '@graphql/fixtures/fixtures.query'
import CurrentFutureSeriesList from '@shared/components/currentFutureSeriesList'
import NoData from '../noData'
import NavPills from '../navPills'

const MATCH_TYPE = [
  {
    sValue: 'i',
    sLabel: 'International'
  },
  {
    sValue: 'l',
    sLabel: 'League'
  },
  {
    sValue: 'd',
    sLabel: 'Domestic'
  },
  {
    sValue: 'w',
    sLabel: 'Women'
  }
]

export default function CricketSeriesContent({ data }) {
  const [requestParams, setRequestParams] = useState({
    eCategory: 'i',
    sSearch: ''
  })
  const [seriesData, setSeriesData] = useState(data?.listFixtureSeries)
  const [getSeries] = useLazyQuery(CURRENT_FUTURE_SERIES, {
    onCompleted: data => {
      setSeriesData(data.listFixtureSeries)
    }
  })
  const [selectedPill, setSelectedPill] = useState(MATCH_TYPE[0].sValue)

  const handleCategoryFilter = value => {
    setRequestParams({ ...requestParams, eCategory: value })
    getSeries({ variables: { input: { ...requestParams, eCategory: value } } })
  }

  function handlePills(pill) {
    setSelectedPill(pill)
    handleCategoryFilter(pill)
  }

  return (
    <div className="position-relative">
      <NavPills navPillsData={MATCH_TYPE} selectedPill={selectedPill} setSelectedPill={handlePills} />
      <CurrentFutureSeriesList data={seriesData} />
      {seriesData?.length === 0 ? <NoData title='Quiet now, but the action is just around the corner. Keep your gear ready!'/> : null}
    </div>
  )
}

CricketSeriesContent.propTypes = {
  data: PropTypes.object
}
